import { Injectable, Injector, Inject, PLATFORM_ID, NgZone, EventEmitter } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";

import { FirebaseService } from "../firebase/firebase.service";

let $_: any;

export interface IEvent {

    id?: string;
    parent_agency_id: string;
    agency_id: string;
    lng: number;
    lat: number;
    city: string;
    cross_streets: string;
    street: string;
    units: string;
    time: Date;
    level: string;
    status: string;
    type: string;
    agencies: string;
    active: boolean;
}

export class Event implements IEvent {

    id?: string;
    parent_agency_id: string;
    agency_id: string;
    lng: number;
    lat: number;
    city: string;
    cross_streets: string;
    street: string;
    units: string;
    time: Date;
    level: string;
    status: string;
    type: string;
    agencies: string;
    active: boolean;
    marker_data: any;
    update_on_map: Function;
    view_map: boolean = false;

    constructor(event: IEvent) {

        this.id = event.id;
        this.parent_agency_id = event.parent_agency_id;
        this.agency_id = event.agency_id;
        this.lng = event.lng;
        this.lat = event.lat;
        this.city = event.city;
        this.cross_streets = event.cross_streets;
        this.street = event.street;
        this.units = event.units;
        this.time = event.time;
        this.level = event.level;
        this.status = event.status;
        this.type = event.type;
        this.agencies = event.agencies;
        this.active = event.active;
    }
}

@Injectable()
export class EventsService {

    db_read_complete: boolean = false;
    private events: IEvent[] = [];
    public item_changed$: EventEmitter<Event>;

    constructor(private ngz: NgZone, @Inject(PLATFORM_ID) private platformId: Object, private fb: FirebaseService) {

        $_ = this;

        $_.item_changed$ = new EventEmitter();
    }

    private sort_events() {

        if ($_.db_read_complete) {

            $_.events.sort((eventa: Event, eventb: Event) => {

                return eventa.time > eventb.time ? -1 : 1;
            })
        }

        return $_.events;
    }

    public get_events(parent_agency_id: string, complete: (events: IEvent[]) => void) {

        $_.events = [];
        $_.db_read_complete = false;

        if (isPlatformBrowser($_.platformId)) {

            if ($_.unsubscribe) {

                $_.unsubscribe();
            }

            $_.query = $_.fb.db.collection("events").where('active', '==', true);

            if (parent_agency_id !== '') {

                $_.query = $_.query.where('parent_agency_id', '==', parent_agency_id);
            }

            $_.unsubscribe = $_.query.onSnapshot((querySnapshot : any) => {

                const creates = querySnapshot.docChanges.filter(event => event.type === "added");
                const updates = querySnapshot.docChanges.filter(event => event.type === "modified");
                const deletes = querySnapshot.docChanges.filter(event => event.type === "removed");

                creates.forEach(event => $_.create_event(event));
                updates.forEach(event => $_.update_event(event));
                deletes.forEach(event => $_.delete_event(event));

                $_.db_read_complete = true;

                complete($_.sort_events());

            }, (error : any) => console.log("Error getting events: ", error));
        }
    }

    private create_event(doc: any) {

        const event: IEvent = doc.doc.data();

        event.id = doc.doc.id;

        $_.events.push(new Event(event));
        $_.item_changed$.emit(event);

        $_.sort_events();
    }

    private update_event(doc: any) {

        var index = $_.events.findIndex(event => event.id === doc.doc.id);

        if (index > -1) {

            $_.events[index] = Object.assign($_.events[index], doc.doc.data());

            $_.item_changed$.emit($_.events[index]);
        }

        $_.sort_events();
    }

    private delete_event(doc: any) {

        var index = $_.events.findIndex(event => event.id === doc.doc.id);

        if (index > -1) {

            $_.item_changed$.emit($_.events[index]);

            $_.events.splice(index, 1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/events/events.service.ts